<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('mating.Date') }}</h5>
    <p class="mb-0 text-sm">{{ $t('common.Mandatory_informations') }} *</p>
    <p class="mb-0 text-sm font-weight-bolder">{{ $t('mating.NB_For_a_specific_deck_date_only_enter_the_date_from') }}</p>
    <p class="mb-0 text-sm text-green" v-if="localFormData.maleLeased && localFormData.selectedLeaseUBN">{{ $t('mating.Male_leased_from_UBN') }} {{ localFormData.selectedLeaseUBN }}</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">          
          <div class="col-4">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('mating.Date_from') }} *</label>
                  <input v-model="localFormData.dateFrom" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('mating.Date_from')">
                  <span v-if="v$.dateFrom.$error" class="text-sm text-danger">
                      {{ v$.dateFrom.$errors[0].$message }}
                  </span>
              </div>
          </div>
          <div class="col-4">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('mating.Date_to') }}</label>
                  <input v-model="localFormData.dateTo" type="date" class="form-control form-control-default" :placeholder="$t('mating.Date_to')">
                  <span v-if="v$.dateTo.$error" class="text-sm text-danger">
                      {{ v$.dateTo.$errors[0].$message }}
                  </span>
              </div>
          </div>          
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="validateAndPrevStep">{{ $t('common.Prev') }}</button>        
      </div>
    </div>
  </div>
</template>
<script>
  import { computed, reactive, watch } from 'vue'
  import useVuelidate from '@vuelidate/core'
  import { required, helpers } from '@vuelidate/validators'
  import { useI18n } from 'vue-i18n'

  export default {
    name: "DateSection",
    props: {      
      formData: Object,
      prevStep: Function
    },
    setup(props, { emit }) {
      const { t } = useI18n()
      const localFormData = reactive({ ...props.formData })
      const todayDate = new Date().toISOString().split('T')[0];    
      const dateToAfterOrEqualDateFrom = helpers.withMessage(
        t('common.Date_to_must_be_greater_than_or_equal_to_Date_from'),
        (value, vm) => {
          //console.log("Validator triggered: from", vm.dateFrom, "to", value)
          if (!value || !vm.dateFrom) return true

          const from = new Date(vm.dateFrom)
          const to = new Date(value)

          return !isNaN(to) && !isNaN(from) && to >= from
        }
      )
            
      const rules = computed(() => {
          return {
              dateFrom: { required: helpers.withMessage(t('common.Required'), required) },
              dateTo: { dateToAfterOrEqualDateFrom }              
          }
      })  

      const v$ = useVuelidate(rules, localFormData)

      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })
      
      const validateAndPrevStep = async () => {
        v$.value.$touch()
        if (v$.value.$pending) {
          await v$.value.$validate()
        }
        if (!v$.value.$invalid) {
          Object.assign(props.formData, localFormData)
          props.prevStep()
        }
      }

      const validateAndSubmit = async () => {        
        v$.value.$touch()
        const isValid = await v$.value.$validate()
        if (!isValid) return

        console.log('here');

        Object.assign(props.formData, localFormData)
        emit('submit')
        return true
      }     

      return {
        localFormData,
        v$,
        validateAndPrevStep,
        validateAndSubmit,
        todayDate
      }
    }    
};
</script>